export const X_ORG_TOKEN = "ENCODE://+ORG_TOKEN";
export const BASE_URL = "https://api.edearn.in/api"
// export const BASE_URL = "http://localhost:4000/api";